import formConfig from './tableau';

describe('tableau form config', () => {
  it('is live', () => {
    expect(formConfig.live).toBe(true);
  });

  it('enables user registration and required question indicators', () => {
    expect(formConfig.register).toBe(true);
    expect(formConfig.requiredFlag).toBe(true);
    expect(formConfig.approval).toBeUndefined();
  });

  it('shows the Tableau license request sections', () => {
    expect(formConfig.sections).toEqual([
      expect.objectContaining({
        title: 'Request a Tableau license',
        subsections: [
          expect.objectContaining({ title: 'Your details' }),
          expect.objectContaining({ title: 'Spend approval (if applicable)' }),
        ],
      }),
    ]);
    expect(formConfig.approvalAllowUnsubmit).toBe(false);
  });

  it('collects the requester, team, licence count and licence users in details', () => {
    const details = formConfig.sections[0].subsections.find(({ slug }) => slug === 'cover-sheet');

    expect(details?.pages[0]).toEqual(
      expect.objectContaining({
        questions: expect.arrayContaining([
          expect.objectContaining({
            name: 'requester-name',
            title: 'What is your name',
            hint: 'Firstname Lastname',
            userNameFromEmail: true,
            rules: { required: true },
          }),
          expect.objectContaining({
            name: 'tableau-contact-email',
            title: 'Your email address',
            userEmail: true,
            rules: { required: true, email: true },
          }),
          expect.objectContaining({
            name: 'department-or-organisation',
            rules: { required: true },
          }),
          expect.objectContaining({
            name: 'team-name',
            hint: 'Team name',
            rules: { required: true },
          }),
          expect.objectContaining({
            name: 'team-purpose',
            rules: { required: true },
          }),
          expect.objectContaining({
            name: 'number-of-tableau-users',
            rules: expect.objectContaining({
              required: true,
              number: true,
              min: 1,
              pattern: '^\\d+$',
            }),
          }),
          expect.objectContaining({
            name: 'single-license-for-requester',
            showWhen: [
              {
                field: 'number-of-tableau-users',
                condition: 'equals',
                value: '1',
              },
            ],
          }),
          expect.objectContaining({
            name: 'tableau-license-users',
            rules: { required: true },
            dynamicTable: expect.objectContaining({
              showExcelToolbar: false,
              rowHeader: 'User Email Address',
              rowCountField: 'number-of-tableau-users',
              strict: true,
              rows: [],
            }),
          }),
          expect.objectContaining({
            name: 'paid-for-tableau-licence-last-financial-year',
            title: 'Were you required to pay for your Tableau licence last financial year?',
            options: ['Yes', 'No'],
            rules: { required: true },
          }),
          expect.objectContaining({
            name: 'team-used-to-be-part-of-gpg',
            title: 'Was this team part of the Government People Group (GPG) last year?',
            options: ['Yes', 'No'],
            rules: { required: true },
            showWhen: [
              {
                field: 'paid-for-tableau-licence-last-financial-year',
                condition: 'equals',
                value: 'No',
              },
            ],
          }),
          expect.objectContaining({
            name: 'tableau-licence-funding-information',
            description:
              '<p>We will check whether your licence is centrally funded. If it is not, we will contact you to discuss your options. Paid licences cost &pound;1,850 per user per year.</p>',
            showWhen: [
              {
                field: 'paid-for-tableau-licence-last-financial-year',
                condition: 'equals',
                value: 'No',
              },
            ],
          }),
        ]),
      }),
    );
  });

  it('locks spend approval behind details and skips it when last year was centrally funded', () => {
    const spendApproval = formConfig.sections[0].subsections.find(
      ({ slug }) => slug === 'spend-approval',
    );

    expect(spendApproval).toEqual(
      expect.objectContaining({
        dependsOn: 'cover-sheet',
        notRequiredWhen: [
          {
            field: 'paid-for-tableau-licence-last-financial-year',
            condition: 'equals',
            value: 'No',
          },
        ],
      }),
    );
    expect(spendApproval?.pages[0]).toEqual(
      expect.objectContaining({
        title: 'Spend approval',
        disabled: [
          {
            field: 'paid-for-tableau-licence-last-financial-year',
            condition: 'equals',
            value: 'No',
          },
        ],
        questions: expect.arrayContaining([
          expect.objectContaining({
            name: 'agree-to-pay-the-charge',
            title: 'Do you agree to pay the charge?',
            options: ['Yes', 'No'],
            rules: { required: true },
          }),
          expect.objectContaining({
            name: 'person-approving-charge',
            title: 'Name of person approving charge',
            hint:
              'Please ensure this person has the appropriate budget authority to sign off the purchase',
            rules: { required: true },
          }),
        ]),
      }),
    );
  });
});
